import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Company } from '../../store/company/types'
import { updateCompany as updateCompanyAction } from '../../store/company/actions'
import { getEditingCompany } from '../../store/company/selectors'
import { Redirect } from 'react-router'

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    selected: Company
    route:any
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    updateCompany: typeof updateCompanyAction
}
interface State {
    selected: Company
    fireRedirect:Boolean
}
// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch


class CompanyEditPage extends React.Component<AllProps,State > {

    constructor(props: AllProps) {
        super(props)
        this.state = {
            fireRedirect: false, selected: this.props.selected};//{ id: 0, name: '', roles: [] }
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    public componentDidMount() {
        //const { fetchRequest: fr } = this.props
        //fr()
        //const {   selected } = this.props
        //if(this.props.selected)
        //this.setState(this.props.selected)
    }

    componentDidUpdate(prevProps: AllProps) {
        /*if (this.props.selected && prevProps.selected && prevProps.selected.id !== this.props.selected.id)
        {    
            this.setState(this.props.selected)
        }
        */
        
        /*else if (this.props.selected === null)
        {
            this.setState( { id: 0, name: '', roles: [] })

        }
        */
        
    }


    handleOnChange: React.ReactEventHandler<HTMLInputElement> = ev => {
        this.setState({ ...this.state,selected:{ ...this.state.selected, name: ev.currentTarget.value}  })
    };

    handleUpdate = (ev:React.MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault()
        if (this.props.selected) {
            this.props.updateCompany(this.state.selected)
            this.setState({ fireRedirect:true})

        }
    };
    private renderData() {
        const { from } = this.props.route.location.state || '/'
    
        const state = this.state.selected
        return (
            <div>
                {
                    state.name !== undefined && state.name != null && state.name !== "" && (
                        <span>
                            <input type="text" value={state.name} onChange={this.handleOnChange} />
                            <button onClick={this.handleUpdate} >Update</button>
                        </span>
                        // <input type="text" value={this.props.selected.name} onChange={this.handleOnChange} />
                    )

                }
                {
                    this.state.fireRedirect  && (
                        <Redirect to={from || '/Company/Company/' +state.id}/>
                    )
                }

            </div>
        )
    }

    public render() {

        return (
            <div>
                {this.renderData()}
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    //data:company.data,
    selected: getEditingCompany(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    updateCompany: updateCompanyAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyEditPage)
